<template>
  <div class="col-xs-12  modal fade" id="HeadlinesModal" data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content headlines-modal-wrapper container">
        <div class=" row modal-header m-0 scrollable-content">
          <div class="col-xs-12 col-sm-6 col-md-12 p-0 d-flex">
            <div v-if="type == 'add'" class="text-capitalize add-headline ">{{$t('addHeadline')}}</div>
            <div v-else class="text-capitalize add-headline ">{{$t('editHeadline')}}</div>
            <div class="cursor-pointer close-icon-outer" @click="closeModal()">
              <img class="pr-24" src="/static/images/icons/AddEditHeadline_Close_Icon.svg" />
            </div>
          </div>
          <div class="col-xs-12 p-0 header-line"><hr/></div>
          <div class="form-main">
            <div class="col-xs-12 p-0 mb-33 pt-17">
              <label>{{$t('headlinesLabel')}} <span class="danger">*</span></label>
              <div class="form-group">
                <input maxlength="130" v-model="$v.formDetails.title.$model" type="text" :placeholder="$t('enterHeadline')"
                  class="form-control common-input" style="min-height: 44px;"  @blur="$v.formDetails.title.$touch()"/>
              </div>
            </div>

            <div class="col-xs-12 p-0 mb-33 d-flex col-gap-24 xs-flex-column">
              <!-- <div class="col-xs-12 col-sm-6 p-0">
                <label>{{$t('role')}} <span class="danger">*</span></label>
                <multiselect
                  :showLabels="false"
                  label="role_name"
                  openDirection="below"
                  class="product-class-ellipsis multiselect-single-dropdown"
                  v-model="selectedRole"
                  :options="rolesList"
                  :placeholder="$t('selectRole')"
                >
                </multiselect>
              </div> -->
              <div class="col-xs-12 p-0 col-sm-6 custom-date-picker">
                <label>{{$t('date')}} <span class="danger">*</span></label>
                <date-picker type="date" :format="formatDate" :editable="true"
                :lang="this.$i18n.locale === 'English' ? getEnglishPicker : getPortuguesePicker" @change="isValidDate()"
                  :placeholder="this.$i18n.locale === 'English' ?$t('englishDatePlaceholder') :$t('portugueseDatePlaceholder')" v-model="$v.formDetails.display_date.$model" :append-to-body="false" :disabled-date="disableDateBeforeToday"
                  :popup-style="{ top: 10, left: 0 }">
                  <i slot="icon-calendar">
                    <img src="/static/images/icons/date-picker-calender-icon.svg" alt="calender-icon">
                  </i>
                </date-picker>
                <div class="custom-error-class pt-7" v-if="showMessage">{{$t('displayDateValidation')}}</div>
                <div class="custom-error-class pt-7" v-if="showDateValidation">{{$t('displaydate')}}</div>
              </div>
              <div class="col-xs-12 col-sm-6 p-0">
                <label>{{$t('websiteUrl')}}</label>
              <div class="form-group">
                <input :placeholder="$t('enterUrl')"
                :class="{'invalid-border': $v.formDetails.redirection_url.$error}"
                  v-model="$v.formDetails.redirection_url.$model" type="text" class="form-control common-input" style="min-height: 36px;" />
              </div>
              <div v-if="$v.formDetails.redirection_url.$error" class="custom-error-class pt-5">
                {{ $t('urlValidation') }}
              </div>
              </div>
            </div>
            <div class="col-xs-12 p-0 mb-33">
              <label>{{$t('description')}} <span class="danger">*</span></label>
              <div class="form-group">
                <textarea maxlength="300" v-model="$v.formDetails.description.$model" type="text" :placeholder="$t('enterDescription')"
                  class="form-control common-input" rows="6" style="min-height: 96px;"></textarea>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 p-0 mb-8">
              <label>{{$t('uploadImage')}} <span class="danger">*</span></label>
              <div @drop.prevent.stop="getDroppedFile" @dragover.prevent.stop="onDragOver"
                class="upload-area">
                <div class="d-flex flex-direction-column align-items-center row-gap-20">
                  <img src="/static/images/icons/Headlines_Upload_icon.svg" alt="" class="upload-image">
                  <span class="file-header-text font-300 pb-16">{{ $t('imageValidation1')}}</span>
                </div>
                <input type="file" ref="headLineFile" id="newHeadLine" class="hidden"  @change="setSelectedFile"/>
                <button for="newHeadLine" class="btn btn-block blue_outline_upload_button" @click="openFileUpload">{{$t('upload')}}
                </button>
                <div class="selected d-flex justify-content-center" v-if="fileName" :title="fileName">
                  <div class="pr-15 word-break file-name">{{ actionType === "add" ? fileName : fileName | decodeFileName }}</div>
                  <img class="cursor-pointer delete-icon" src="/static/images/icons/Headlines_Delete_icon.svg" @click="clearSelectedFile"/>
                </div>
                <div class="col-xs-12 text-center" v-if="errorText">
                  <div class="error-message danger">{{ errorText }}</div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-24 footer-buttons pr-24">
            <button class="btn btn-block blue_outline_cancel_button" @click="closeModal">{{$t('cancel')}}</button>
            <button type="button" class="blue_save_changes_button" :disabled="disabledSave||showMessage||showDateValidation"  @click="addEditHeadLine">{{$t('save')}}</button>
          </div>

          <!-- <discard-form-changes-popup @navigateBackToListView="discardAllFormChanges"></discard-form-changes-popup> -->
          <loader :loadingStatus="loaderStatus"></loader>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { isEqual, cloneDeep } from 'lodash';
import moment from 'moment';
import $ from 'jquery';

import DatePicker from 'vue2-datepicker';
import Loader from '../UIComponents/Loader.vue';
// import getSasToken from '../../apis/sasToken';
// import upload from '../../apis/azureUpload';
import { removeEncodedChar } from '../../utils/common';
import {
  updateHeadline,
  addHeadline,

} from '../../apis/headlines';
// import { getListOfRoleNames } from '../../apis/rbac';
import { mainHeadLineValidations } from './validations';
import translation from '../UIComponents/mixins/translationMixins';

export default {
  props: {
    roleId: Number,
    editDetails: Object,
    type: String,
  },
  data() {
    return {
      formatDate: {
        stringify: (date) => (date ? moment(date).format(this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY') : null),
        parse: (value) => {
          const date = moment(value, this.$i18n.locale === 'Portuguese' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
          if (!date.isValid()) {
            if (value) this.showDateValidation = true;
            this.$v.formDetails.display_date.$model = '';
            return '';
          }
          this.showDateValidation = false;
          // eslint-disable-next-line no-underscore-dangle
          return value ? moment(date)._d : null;
        },
      },
      loaderStatus: false,
      selectedFile: null,
      errorText: '',
      sasToken: '',
      headLineType: '',
      actionType: '',
      formDetails: {
        title: '',
        description: '',
        redirection_url: '',
        display_date: '',

      },
      fileName: '',
      formDetailsCopy: {},
      selectedHeadLineDetails: {},
      isFileUploaded: false,
      isDiscardFileChanges: false,
      action: '',
      rolesList: [],
      selectedRole: '',
      showMessage: false,
      showDateValidation: false,
    };
  },

  components: {
    // DiscardFormChangesPopup,
    DatePicker,
    Loader,
  },
  validations() {
    return {
      formDetails: mainHeadLineValidations,
    };
  },
  mixins: [translation],
  computed: {
    disabledSave() {
      if (this.type === 'add') {
        return this.$v.formDetails.$invalid || !this.selectedFile;
      }
      const isFormNotChanged = isEqual(this.formDetailsCopy, this.formDetails);
      if (!isFormNotChanged) {
        return this.$v.formDetails.$invalid || !this.fileName;
      }
      // let roleId = '';

      // if (this.selectedRole) {
      //   roleId = this.selectedRole[0] ? this.selectedRole[0].role_id : this.selectedRole.role_id;
      // }
      return isFormNotChanged && !this.isFileUploaded;
    },
  },

  filters: {
    decodeFileName(filepath) {
      if (!filepath) {
        return '';
      }
      return removeEncodedChar(filepath);
    },
  },
  watch: {
    editDetails() {
      // this.selectedHeadLineDetails = this.editDetails;
      if (this.type === 'add') {
        this.clearForm();
      }
      // else {
      //   this.selectedRole = this.rolesList.filter((role) => role.role_id === this.editDetails.role_id);
      // }
    },
  },
  // async created() {
  //   this.rolesList = (await getListOfRoleNames()).filter((role) => role.role_id !== 66);
  // },

  methods: {
    isValidDate() {
      this.showMessage = false;
      const time1 = moment(this.formDetails.display_date).format('YYYY-MM-DD');
      const today = new Date();
      const time2 = moment(today).format('YYYY-MM-DD');
      if (time1 < time2) {
        this.showMessage = true;
      }
    },
    disableDateBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },

    onDragOver(event) {
      event.dataTransfer.dropEffect = 'copy';
    },

    getDroppedFile(event) {
      if ([...event.dataTransfer.files].length === 1) {
        const [selectedFile] = [...event.dataTransfer.files];
        const isAnyErrorExists = this.validateFileType(selectedFile);
        if (isAnyErrorExists) return;
        this.checkImageDimension(selectedFile);
      } else if ([...event.dataTransfer.files].length > 1) {
        this.errorTxt = this.$i18n.locale === 'Portuguese' ? 'Selecione apenas um arquivo por vez' : 'Please select only one file at a time';
      }
    },
    checkImageDimension(selectedFile) {
      let errorText = '';
      const img = new Image();
      img.src = URL.createObjectURL(selectedFile);
      img.onload = () => {
        const { height, width } = img;
        if ((width !== 298 || height !== 182)) {
          errorText = this.$i18n.locale === 'Portuguese' ? 'Imagem com dimensões 298x182 é permitida' : 'Image with dimensions 298x182 is allowed';
        }
        if (!errorText) {
          this.setFileDetails({
            file: selectedFile,
            fileName: selectedFile.name,
            errorText: '',
            isFileUploaded: true,
          });
        } else {
          this.setFileDetails({
            file: null,
            fileName: '',
            errorText,
            isFileUploaded: false,
          });
        }
      };
    },
    setSelectedFile() {
      const [selectedFile] = this.$refs.headLineFile.files;
      if (!selectedFile) return;
      const isAnyErrorExists = this.validateFileType(selectedFile);
      if (isAnyErrorExists) return;
      this.checkImageDimension(selectedFile);
    },

    validateFileType(fileDetails) {
      const fileExtension = fileDetails.name.split('.').pop();
      if (!['jpg', 'jpeg', 'png'].includes(fileExtension)) {
        this.errorText = this.$i18n.locale === 'Portuguese' ? 'Tipo de arquivo jpg, jpeg permitido' : 'File type jpg,jpeg allowed';
      } else {
        this.errorTxt = '';
      }
      return this.errorTxt;
    },
    setFileDetails({
      file, fileName, errorText, isFileUploaded,
    }) {
      this.selectedFile = file;
      this.errorText = errorText;
      this.fileName = fileName;
      this.isFileUploaded = isFileUploaded;
    },
    async addEditHeadLine() {
      this.closeModal();
      this.loaderStatus = true;
      const displayDate = moment(this.formDetails.display_date).format('YYYY-MM-DD HH:mm:ss.SSS');
      const formData = new FormData();
      formData.append('document', this.selectedFile);
      formData.append('title', this.formDetails.title);
      formData.append('description', this.formDetails.description);
      formData.append('redirectionUrl', this.formDetails.redirection_url);
      formData.append('displayDate', displayDate);
      if (this.selectedFile === null) formData.append('image', this.formDetails.image);
      else formData.append('image', this.selectedFile.name);
      if (this.formDetails.id) {
        formData.append('id', this.formDetails.id);
      }
      const response = this.formDetails.id ? await updateHeadline(formData) : await addHeadline(formData);
      if (response) {
        this.loaderStatus = false;
        if (response.status === 204) {
          this.addMemberError = response.message;
          this.clearNotifications();
          const addMessage = this.$i18n.locale === 'Portuguese' ? 'Notícia adicionada com sucesso!' : 'Headline added successfully!';
          const editMessage = this.$i18n.locale === 'Portuguese' ? 'Notícia editada com sucesso!' : 'Headline edited successfully!';
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text: this.formDetails.id ? editMessage : addMessage,
            group: 'custom-notification',
          });
          this.clearForm();
          this.$emit('getHeadlines');
        } else {
          this.clearNotifications();
          const addMessage = this.$i18n.locale === 'Portuguese' ? 'Falha ao adicionar título' : 'Adding headline failed';
          const editMessage = this.$i18n.locale === 'Portuguese' ? 'A edição do título falhou' : 'Editing headline failed';
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.formDetails.id ? editMessage : addMessage,
            group: 'custom-notification',
          });
        }
      } else {
        this.loaderStatus = false;
        this.clearNotifications();
        const addMessage = this.$i18n.locale === 'Portuguese' ? 'Falha ao adicionar título' : 'Adding headline failed';
        const editMessage = this.$i18n.locale === 'Portuguese' ? 'A edição do título falhou' : 'Editing headline failed';
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.formDetails.id ? editMessage : addMessage,
          group: 'custom-notification',
        });
      }
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    closeModal() {
      $('#HeadlinesModal').modal('hide');
      this.$refs.headLineFile.value = '';
      this.fileName = '';
      this.errorText = '';
    },
    openFileUpload() {
      $('#newHeadLine').click();
    },
    sortBy() {

    },
    setFormDetails() {
      // eslint-disable-next-line camelcase
      const { description, redirection_url, title } = this.selectedHeadLineDetails;
      this.formDetails = {
        ...this.formDetails, description, redirection_url, title,
      };
      this.formDetails.image = this.selectedHeadLineDetails.image;
      this.formDetails.id = this.selectedHeadLineDetails.id;
      this.fileName = this.selectedHeadLineDetails.image.split('/').pop();
      this.formDetails.display_date = new Date(this.selectedHeadLineDetails.display_date);
      // this.selectedRole = this.rolesList.filter((role) => role.role_id === this.selectedHeadLineDetails.role_id);

      this.formDetailsCopy = cloneDeep(this.formDetails);
      // this.$v.$reset();
    },
    // openFileUpload() {
    //   $('#newHeadLine').click();
    // },
    clearSelectedFile() {
      this.$refs.headLineFile.value = '';
      this.selectedFile = null;
      this.isFileUploaded = false;
      this.fileName = '';
      this.errorText = '';
    },

    showToaster(response) {
      if (response && response.status_code === 200) {
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: response.data,
          group: 'custom-notification',
        });
        this.isDiscardFileChanges = true;
        this.$router.push(`/layout/dashboard/${this.headLineType}`);
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response?.message || 'Please try again later',
          group: 'custom-notification',
        });
      }
    },

    discardAllFormChanges() {
      this.isDiscardFileChanges = true;
      this.navigateBack();
    },

    isIgnoreFormChanges() {
      if (this.isDiscardFileChanges) return false;
      if (this.actionType === 'add' && (this.$v.$anyDirty || this.selectedFile)) return true;
      if (this.actionType === 'edit' && (this.$v.$anyDirty || (this.selectedFile || !this.fileName))) return true;
      return false;
    },

    openDiscardFormChangesPopup() {
      $('#discard-from-changes').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    navigateBack() {
      this.$router.go(-1);
    },
    clearForm() {
      this.formDetails.display_date = '';
      this.fileName = '';
      this.formDetails.title = '';
      this.formDetails.description = '';
      this.formDetails.redirection_url = '';
      this.formDetails.id = '';
      // this.selectedRole = '';
      this.selectedFile = null;
    },
  },
};

</script>

<style scoped>
/* .product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
} */
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.pt-17 {
  padding-top: 17px;
}
.pt-7 {
  padding-top: 7px;
}
.mb-8 {
  margin-bottom: 8px;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 36px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 36px;
    padding: 4px 40px 4px 12px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 6px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    border: 1px solid #000000;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    /* border: 1px solid #0b3c61; */
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 5px;
    top: 0px;
    content: "";
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    border:1px solid #0A99ff !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border:1px solid #0A99ff !important;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    border:1px solid #0A99ff !important;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected span{
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #000000;
    opacity:0.5;
    width: 95%;
  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
    color: #828282;
    overflow: visible;
    padding-left:0px;
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 25px;
    color: #333333;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 12px;
    padding-top:6px;
    padding-bottom: 0px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border: 1px solid black;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.delete-icon{
  margin-top: 28px;
  height: 18px;
  width: 18px;
}
.custom-date-picker .mx-datepicker >>> .mx-input:hover{
  border: 0.5px solid #000000;
}
/* .custom-date-picker >>> .mx-input:focus,
.custom-date-picker >>> .mx-input:hover{
  border-collapse: #000000 !important;
} */
.form-control{
  min-height: 34px !important;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  border-radius: 3px;
  color: #4D4D4D;
  border: 1px solid #4D4D4D;
}
.form-control::placeholder{
  color: #999999;
}
.footer-buttons button:disabled {
  cursor: not-allowed;
}
.pr-24{
  padding-right: 24px;
}
.close-icon-outer{
  position: absolute;
  right: -10px;
  top: 19px;
}
.modal-open .modal {
  overflow: hidden;
}

.modal-main {
  width:60%;
  margin-top: 10px;
}
.file-name{
  margin-top: 24px;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #01518A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}
/* .modal .modal-dialog .modal-content {
  border-radius: 10px;
} */

.modal .modal-dialog .modal-content .modal-header {
  background: #FFFFFF;
  border-radius: 8px;
  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 24px; */
}

.modal-header {
  padding: 0px;
  border-bottom: 0px;
}
.container {
  /* position: absolute; */
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
  max-height: calc(88vh - 10px);
  padding-left: 256px;
  padding-right: 0px;
  /* margin-top: 269px; */
}

.scrollable-content {
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
  /* padding-left: 32px; */
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
  /* margin-left: 20px; */
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;

}

.headlines-modal-wrapper {
  width: 944px;
  /* padding: 24px 0px 0px 24px; */
  padding: 0px;
  /* padding-right:2px */
}

.add-headline {
  font-weight: 600;
  font-size: 20px;
  color: #1A1A1A;
  padding: 19px 0 0 16px;
}

.header-line {
 padding: 18px 0px 9px 0px;
}
.header-line hr{
  border-top: 0.7px solid #BDBDBD;
  margin: 0px;
}

.footer-line {
  padding: 10px 25px 0px 8px;
  margin-bottom: 23px;
}
.footer-line hr{
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  margin: 0px;
}
.blue_outline_upload_button,
.blue_outline_upload_button:hover,
.blue_outline_upload_button:focus{
  background-color: #E6E6E6;
  height: 34px;
  max-width: 88px;
  color: #404040;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  padding: 7px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: auto;
}

.blue_outline_cancel_button,
.blue_outline_cancel_button:hover,
.blue_outline_cancel_button:focus
 {
  background-color: #E6E6E6;
  /* height: 44px; */
  color: #404040;
  font-size: 18px;
  width: 90px;
  height: 44px;
  font-weight: 600;
  border-radius: 3px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  /* margin-bottom: 24px; */
}

.blue_save_changes_button,
.blue_save_changes_button:hover {
  background-color: #01518A;
  height: 44px;
  border-radius: 3px;
  min-width: 73px;
  cursor: pointer;
  border: none;
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin-top: 0px !important;
  padding: 10px 16px;
}

.footer-buttons {
  padding-bottom: 16px;
  padding-top: 16px;
  padding-right: 16px !important;
  background-color: #FAFAF9;
  min-height: 76px;
}
.form-main {
  padding-right: 27px;
  padding-left: 32px;
}

.upload-image {
  padding-top: 32px;
  padding-bottom: 8px;
}

.form-group {
  margin-bottom: 0px;
}

.p-24 {
  padding: 24px;
}

.pb-16 {
  padding-bottom: 16px;
}

.page-title {
  font-size: 24px;
  font-weight: 400;
  line-height: 40px;
  color: #0b3c61;
  margin-top: 0px;
}

.danger {
  color: #B00505;
}
.error-message{
  margin-top: 24px;
}

label {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #3E3E3E;
}

/* Custom date picker */
.custom-date-picker .mx-datepicker>>>.mx-input-wrapper .mx-icon-calendar {
  left: 6px;
  right:auto
}

.custom-date-picker .mx-datepicker>>>.mx-input-wrapper .mx-icon-clear {
  left: 10px;
  height: 16px;
  width: 16px;
}

.custom-date-picker .mx-datepicker>>>.mx-input-wrapper .mx-icon-calendar svg {
  width: 18px;
  height: 20px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  fill: #333333;
}

.custom-date-picker .mx-datepicker>>>.mx-input {
  padding: 8px 13px 8px 34px;
  font-size: 16px;
  color: #1A1A1A;
  border-radius: 3px;
  line-height: 18px;
  font-weight: 400;
  height: 36px;
  border: 1px solid #4D4D4D;
}

.custom-date-picker .mx-datepicker>>>.mx-input::placeholder {
  color: #1A1A1A;
  font-size: 16px;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: #333333;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-content .mx-table-date th {
  font-size: 14px;
  color: #333333;
  font-weight: 700;
  height: 32px;
  /* line-height: 19px;
  text-align: center;
  /* text-transform: uppercase; */
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-content .mx-table .cell.active {
  color: #fff;
  background-color: #01518a;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-left:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-left:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-right:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-double-right:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-left:before {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.custom-date-picker .mx-datepicker>>>.mx-datepicker-main .mx-datepicker-content .mx-datepicker-body .mx-calendar .mx-calendar-header .mx-btn .mx-icon-right:after {
  border-color: #333333;
  border-width: 3px 0 0px 3px;
}

.col-gap-24 {
  column-gap: 24px;
}

/* .form-group .textarea  >>> .form-control {
  height: 140px;
} */
textarea.form-control {
  min-height: 96px !important;
}

/* .form-control-input {
  display: block;
  width: 100%;
  height: 36px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
} */

textarea {
  resize: none;
}

.page-title {
  padding: 0;
}
.upload-area {
  min-height: 217px;
  border-radius: 3px;
  text-align: center;
  /* padding: 0px 0px 27px 0px; */
  border: 0.5px solid #000000;
  background: #FFFFFF;
}

.emergo-blue-button {
  padding: 7px 34px;
}

.text-capitalize {
  text-transform: capitalize;
}

.file-header-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333;
}

.invalid-border {
  border-color: #a20000 !important;
}
@media (min-width: 992px){
  .modal-lg {
    width: 900px !important;
  }
}

.custom-error-class {
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #b00505;
}

@media screen and (max-width: 657px) {
  .xs-flex-column {
    flex-direction: column;
    row-gap: 30px;
  }
}
</style>
